/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import { AvatarComponent } from '../..';
import { FlexContainer } from '../../../globalStyles';
import { device, fontFamily } from '../../constants';
import { ImageContainer } from '../../Common/CommentItem/CommentItem.style';
import { getFormatedTimestamp } from '../../../services/utility/moment';

export const Container = styled.div`
  width: calc(100% - 2rem);
  position: relative;
  background-color: #ebebeb;
  border-radius: 5px;
  margin: 1rem;
`;

export const ItemContainer = styled.div`
  border-radius: 10px;
  box-shadow: -5px -5px 11px #fffffff5;
  padding: 1rem;
  /* margin: 2rem 2.5rem 0rem 0rem; */
  /* padding: 2rem; */
  & .mainDetails {
    font: 1.8rem ${fontFamily.circularMedium};
    color: #4a4a4a;
    margin-bottom: 1rem;
  }
  & .subDetails {
    font: 1.4rem ${fontFamily.circularMedium};
    color: #393939;
  }
`;

export const UsernameText = styled.div`
  color: #4a4a4a;
  font: 1.8rem ${fontFamily.circularMedium};
  &.ml {
    margin-left: 1rem;
  }
`;

export const Content = styled.div`
  color: #404046;
  font: 1.6rem ${fontFamily.circularBook};
  padding-top: 0.2rem;
  &.ml {
    margin-left: 1rem;
  }
`;

const RemarksList = ({ ele }) => {
  const { by, timestamp, remarks } = ele;
  return (
    <Container style={{ marginTop: '2rem' }}>
      <ItemContainer>
        <FlexContainer
          className='jc_spacebetween ai_center'
          style={{ marginBottom: '1rem' }}
        >
          <FlexContainer className='ai_center'>
            <FlexContainer className='ai_center'>
              <ImageContainer style={{ height: '100%' }} className='ai_center'>
                <AvatarComponent userdata={{ firstName: by }} circle={true} />
              </ImageContainer>
              <div>
                <UsernameText
                  style={{ fontSize: '1.6rem' }}
                  className='ml'
                >{`${by}`}</UsernameText>
                <Content className='ml'>
                  {timestamp ? getFormatedTimestamp(timestamp) : '-'}
                </Content>
              </div>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
        <Content className='ml'>
          <p dangerouslySetInnerHTML={{ __html: remarks || '-' }} />
        </Content>
      </ItemContainer>
    </Container>
  );
};

export default RemarksList;
